import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "react-toastify";
import { MdAlternateEmail } from "react-icons/md";
import axios from "axios";
import api from "../utils/api";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post(`/forgot-password`, null, {
        params: { email },
      });
      toast.success("Password reset link has been sent to your email.");
    } catch (err) {
      toast.error("Email not found or error occurred.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen">
      {/* Left Section - Enhanced Animation */}
      <div className="sm:w-1/2 w-full bg-gradient-to-br from-slate-700 to-slate-900 text-white flex flex-col justify-center items-center relative overflow-hidden sm:grid hidden">
        <div className="z-10 text-center px-8">
           <motion.img
                      src="/companylogo.png"
                      alt="Value3D"
                      className="h-16 w-auto mb-6 mx-auto bg-white rounded-lg pr-2 pl-2"
                      initial={{ opacity: 0, y: 0 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.8 }}
                      whileHover={{ scale: 1.1 }}
                    />

          <motion.p
            className="text-lg text-slate-300"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            Enter your email to reset your password
          </motion.p>
          <motion.p
            className="text-lg text-slate-300"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6 }}
          >
            Further instructions will be sent to your email
          </motion.p>
        </div>
      </div>

      {/* Right Section - Enhanced Form */}
      <div className="sm:w-1/2 w-full flex justify-center items-center bg-gradient-to-br from-gray-50 to-gray-100 px-6">
        <motion.form
          onSubmit={handleForgotPassword}
          className="bg-white/80 backdrop-blur-xl p-8 sm:p-10 rounded-2xl shadow-xl w-full max-w-md space-y-6"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h2 className="text-3xl font-bold text-slate-800 mb-6">
            Forgot password
          </h2>

          <div className="space-y-4">
            <div className="relative">
              <MdAlternateEmail className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-xl" />
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full border border-slate-200 pl-10 pr-4 py-3 rounded-full focus:outline-none focus:ring-2 focus:ring-slate-500 focus:border-transparent transition-all duration-200"
                required
              />
            </div>
          </div>

          <motion.button
            type="submit"
            disabled={loading}
            className={`w-full text-white py-3 rounded-full transition duration-200 transform ${
              loading
                ? "bg-slate-400 cursor-not-allowed"
                : "bg-slate-700 hover:bg-slate-800 hover:scale-[1.02] active:scale-[0.98]"
            }`}
            whileHover={!loading && { scale: 1.02 }}
            whileTap={!loading && { scale: 0.98 }}
          >
            {loading ? "Sending..." : "Verify Email"}
          </motion.button>
        </motion.form>
      </div>
    </div>
  );
}

export default ForgotPassword;
